import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import loadable from '@loadable/component';
import { makeStyles } from 'tss-react/mui';
import ButtonPopper from '@components/UI/ButtonPopper';
import NavItem from './NavItem';
import OtherMenu from './OtherMenu';
import useSelectedPlatform from '@hooks/useSelectedPlatform';
import { useUserState } from '@context/UserContext';
import { useFeature } from 'flagged';
const Ellipsis = loadable(() => import('@components/Icons/Ellipsis'));
const useStyles = makeStyles()((theme, { additionalWidth }, classes) => {
    const contentMaxWidth = `${1139 + additionalWidth}px`;
    const marketingMaxWidth = `${1079 + additionalWidth}px`;
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamily,
            borderLeft: `1px solid ${theme.palette.grey[100]}`,
            paddingLeft: '7px',
        },
        navigationLink: {
            color: theme.palette.grey[400],
            marginLeft: '3px',
            marginRight: '3px',
            paddingRight: '10px',
            paddingLeft: '10px',
            height: '55px',
            whiteSpace: 'nowrap',
            position: 'relative',
            '& span': {
                fontSize: '12px',
                fontWeight: 600, // override MUI
            },
            '&[class*="selected"]': {
                color: theme.palette.primary.main,
            },
            '&:hover': {
                backgroundColor: '#F6F7FA',
                borderRadius: '4px',
                height: '35px',
            },
        },
        content: {
            display: 'flex',
            [`@media (max-width: ${contentMaxWidth})`]: {
                display: 'none',
            },
        },
        marketplace: {
            display: 'flex',
            [`@media (max-width: ${marketingMaxWidth})`]: {
                display: 'none',
            },
        },
        button: {
            whiteSpace: 'nowrap',
            borderRadius: '0px',
            height: '55px',
            [`&:hover .${classes.ellipsisIcon}`]: {
                fill: theme.palette.primary.main,
            },
            marginLeft: '3px',
            marginRight: '3px',
            paddingRight: '10px',
            paddingLeft: '10px',
        },
        ellipsisIcon: {
            fill: theme.palette.grey[400],
        },
        popper: {
            zIndex: theme.zIndex.appBar + 2,
        },
    };
});
/**
 * A supplimentary menu to assist users with site-wide navigation
 */
const NavigationSite = () => {
    const { authenticated } = useUserState();
    const additionalWidth = authenticated ? 100 : 0;
    const { classes, cx } = useStyles({ additionalWidth });
    const { platformSlug } = useSelectedPlatform();
    const isMobilePromotionEnabled = !!useFeature('enable_mobile_app_promotion');
    const isWithdrawalOnlyEnabled = !!useFeature('semisonic_phase_2');
    // Check which page we're on
    const pathname = window.location.pathname;
    const isOnContentPage = pathname.startsWith('/content');
    const isOnCompetePage = pathname.includes('/compete');
    const isOnMarketplacePage = pathname.startsWith('/marketplace');
    return (_jsxs("div", { className: classes.container, children: [isWithdrawalOnlyEnabled ? (_jsx(_Fragment, { children: authenticated && (_jsxs(_Fragment, { children: [_jsx(NavItem, { className: classes.navigationLink, to: `/account/details`, linkText: "Account" }), _jsx(NavItem, { className: cx(classes.navigationLink, isMobilePromotionEnabled ? classes.marketplace : ''), to: "/account/transactions/withdrawal", linkText: "Withdraw" })] })) })) : (_jsxs(_Fragment, { children: [_jsx(NavItem, { className: classes.navigationLink, to: `${platformSlug ? `/${platformSlug}` : ''}/compete`, linkText: "Compete", selected: isOnCompetePage }), _jsx(NavItem, { className: cx(classes.navigationLink, isMobilePromotionEnabled ? classes.marketplace : ''), to: "/marketplace", linkText: "Marketplace", selected: isOnMarketplacePage }), _jsx(NavItem, { className: cx(classes.navigationLink, isMobilePromotionEnabled ? classes.content : ''), href: "/content", linkText: "News", selected: isOnContentPage })] })), _jsx(ButtonPopper, { buttonProps: {
                    variant: 'white',
                    className: classes.button,
                    'aria-controls': 'simple-menu',
                    'aria-haspopup': 'true',
                    ariaLabel: 'Other Links',
                    children: _jsx(Ellipsis, { className: classes.ellipsisIcon }),
                }, className: classes.popper, children: _jsx(OtherMenu, {}) })] }));
};
export default NavigationSite;
